import React from 'react';

interface TimetableSectionProps {
  /** Whether itinerary rows carry the SUNSET tag (Almanac S3's pref). */
  tagSunsetStops: boolean;
  onTagSunsetChange: (on: boolean) => void;
}

/** The Timetable row's value on the contents page. */
export function timetableValue(tagSunsetStops: boolean): string {
  return tagSunsetStops ? 'Sunset tags on' : 'Sunset tags off';
}

/**
 * Timetable (one theme, decision 7): the "Tag stops near sunset" switch. The
 * row that opens it already says Timetable, so the body carries no heading.
 */
export const TimetableSection: React.FC<TimetableSectionProps> = ({
  tagSunsetStops,
  onTagSunsetChange,
}) => (
  <div className="alm-timetable">
    <label className="alm-toggle-row">
      <span>Tag stops near sunset</span>
      <input
        type="checkbox"
        role="switch"
        checked={tagSunsetStops}
        onChange={(e) => onTagSunsetChange(e.target.checked)}
      />
    </label>
  </div>
);

export default TimetableSection;
